import React, { useEffect, useRef, useState, useCallback } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Image,
  Divider,
  Form,
  Input,
  Space,
  message,
  Modal,
  Radio,
  Result,
  Row,
  Select,
  Slider,
  Switch,
  Typography,
  Upload
} from 'antd';
import Moment from 'react-moment';
import seguridadProvider from '../../../services/seguridadProvider';
import {
  CalendarOutlined,
  FrownOutlined,
  InfoCircleOutlined,
  SmileOutlined,
  UploadOutlined,
  UserOutlined
} from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/es_ES';
import jwt_decode from 'jwt-decode';
import generalesProvider from '../../../services/generalesProvider';
import FichaPreview from '../pdf/fichaPreview';
import carnetVacunacionProvider from '../../../services/carnetVacunacionProvider';
import administracionProvider from '../../../services/administracionProvider';
import './Carnetvacunacion.css';

const { Text } = Typography;
const { Option } = Select;
const key = 'regitrando';
const CarnetVacunacion = () => {
  const token = localStorage.getItem('token');
  const [mostrarValidarUsuario, setMostrarValidarUsuario] = useState(true);
  const [validado, setvalidado] = useState(false);
  const [puestos, setpuestos] = useState([]);
  const [tokenvalue, settokenvalue] = useState({ exp: 0 });
  const [cargando, setCargando] = useState(false);
  const [cargandoEmpresas, setCargandoEmpresas] = useState(false);
  const [cargandoContacto, setCargandoContacto] = useState(false);
  const [adjunto, setAdjunto] = useState({});
  const [adjuntos, setadjuntos] = useState([]);
  const [empresas, setEmpresas] = useState([]);

  const [isCheckedregunta1_1Dosis, setIsCheckedregunta1_1Dosis] = useState(false);
  const [isCheckedregunta1_2Dosis, setIsCheckedregunta1_2Dosis] = useState(false);
  const [isCheckedregunta1_3Dosis, setIsCheckedregunta1_3Dosis] = useState(false);
  const [isCheckedregunta1_4Dosis, setIsCheckedregunta1_4Dosis] = useState(false);

  const [isDisabledregunta2, setIsDisabledregunta2] = useState(false);

  const [isCheckedregunta1_Ninguno, setIsCheckedregunta1_Ninguno] = useState(false);
  const [isDisabledpregunta1_1fecha, setIsDisabledpregunta1_1fecha] = useState(true);
  const [isDisabledpregunta1_2fecha, setIsDisabledpregunta1_2fecha] = useState(true);
  const [isDisabledpregunta1_3fecha, setIsDisabledpregunta1_3fecha] = useState(true);
  const [isDisabledpregunta1_4fecha, setIsDisabledpregunta1_4fecha] = useState(true);

  const [isDisabledpregunta1CheckboxPregunta1, setIsDisabledpregunta1CheckboxPregunta1] =
    useState(false);
  const [isDisabledpregunta1CheckboxPregunta2, setIsDisabledpregunta1CheckboxPregunta2] =
    useState(true);
  const [isDisabledpregunta1CheckboxPregunta3, setIsDisabledpregunta1CheckboxPregunta3] =
    useState(true);
  const [isDisabledpregunta1CheckboxPregunta4, setIsDisabledpregunta1CheckboxPregunta4] =
    useState(true);
  const [value, setValue] = React.useState(0);
  const [isDisabledpregunta3_si_fecha, setIsDisabledpregunta3_si_fecha] = useState(true);
  const [isDisabledpregunta3_masdeunavez_fecha, setIsDisabledpregunta3_masdeunavez_fecha] =
    useState(true);
  const [restringido, setrestringido] = useState(false);
  const [isCheckedregunta2_Pfizer, setIsCheckedregunta2_Pfizer] = useState(false);
  const [isCheckedregunta2_AztraZeneca, setIsCheckedregunta2_AztraZeneca] = useState(false);
  const [isCheckedregunta2_Sinofarm, setIsCheckedregunta2_Sinofarm] = useState(false);
  const [isCheckedregunta2_Jhonson, setIsCheckedregunta2_Jhonson] = useState(false);
  const [isCheckedregunta2_Synovac, setIsCheckedregunta2_Synovac] = useState(false);
  const [isCheckedregunta2_Otradistinta, setIsCheckedregunta2_Otradistinta] = useState(false);

  useEffect(() => {}, [mostrarValidarUsuario]);

  useEffect(() => {
    generalesProvider.obtenerListaValor(7).then((res: any) => {
      setpuestos(res);
    });
    if (token) {
      const token_decode: any = jwt_decode(token);
      settokenvalue(token_decode);
      const d = new Date(0);
      d.setUTCSeconds(token_decode.exp);
      if (d <= new Date()) {
        setMostrarValidarUsuario(true);
        settokenvalue(null);
        localStorage.removeItem('token');
        message.warning('Finalizo sesión vuelva a ingresar.', 5);
      } else {
        setMostrarValidarUsuario(false);
        obtenerEmpresas().then(() => {
          iniciarValores();
        });
      }
    }
  }, []);

  const iniciarValores = async () => {
    let tk: any = jwt_decode(localStorage.getItem('token'));
    settokenvalue(tk);
    const usr = JSON.parse(tk.data);
    if (usr.RestriccionAcceso == null || !usr.RestriccionAcceso) {
      message.success('Datos validos...');
      await obtenerEmpresas();
      setMostrarValidarUsuario(false);
      form.resetFields();
      const val = {
        Id: usr.Id,
        EmpresaId: usr.EmpresaId,
        ruc: usr.Ruc,
        NombreApellido: usr.Apellidos + ' ' + usr.Nombres,
        Dni: usr.Dni,
        Referencia: usr.ContactoReferencia,
        TelefonoReferencia: usr.TelefonoReferencia,
        Direccion: usr.Direccion,
        Telefono: usr.Telefono,
        Puesto: usr.Puesto,
        Fiebre: false,
        TosSeca: false,
        GustoPerdida: false,
        OlfatoPerdida: false,
        Flema: false,
        CercaniaCovid: null,
        Medicacion: null,
        MedicacionDescripcion: '',
        Terminos: false,
        Observaciones: ''
      };
      form.setFieldsValue(val);
      if (usr.Observacion4) {
        message.success(
          'Se encuentra en observación por cada 4 horas por declarar sintomatologia.',
          10
        );
      }
      setvalidado(true);
    } else {
      setrestringido(true);
      localStorage.removeItem('token');
      if (usr.Aislamiento7) {
        message.success(
          'Se encuentra con restricción de acceso(7 días de aislamiento) por declarar sintomatologia.',
          10
        );
      } else if (usr.Aislamiento14) {
        message.success(
          'Se encuentra con restricción de acceso(14 días de aislamiento) por declarar sintomatologia.',
          10
        );
      } else if (usr.Observacion4) {
        message.success(
          'Se encuentra en observación por cada 4 horas por declarar sintomatologia.',
          10
        );
      } else if (usr.RestriccionAcceso) {
        message.success('Se encuentra con restricción de acceso.', 10);
      }
      form.resetFields();
      setMostrarValidarUsuario(true);
    }
  };

  const [registroOk, setRegistroOk] = useState(false);
  const [ficha, setficha] = useState({
    codigo: '',
    estadoId: 0,
    nombreApellido: '',
    fechaReg: '',
    dni: '',
    direccion: ''
  });
  const [form] = Form.useForm();
  const handleOnFinish = useCallback(
    async (
      val,
      value,
      isCheckedregunta1_1Dosis,
      isCheckedregunta1_2Dosis,
      isCheckedregunta1_3Dosis,
      isCheckedregunta1_4Dosis,
      isCheckedregunta1_Ninguno,
      tokenvalue,
      adjuntos,
      isCheckedregunta2_Pfizer,
      isCheckedregunta2_AztraZeneca,
      isCheckedregunta2_Sinofarm,
      isCheckedregunta2_Jhonson,
      isCheckedregunta2_Synovac,
      isCheckedregunta2_Otradistinta
    ) => {
      if (tokenvalue) {
        const d = new Date(0);
        d.setUTCSeconds(tokenvalue.exp);
        if (d <= new Date()) {
          //FINALIZO
          message.loading({
            content: 'Finalizo su sesión...Se recargara la pagina en 3 segundos...',
            key
          });
          setTimeout(() => window.location.reload(), 3000);
        } else {
          if (value == 0) {
            message.warn('Por los menos marque una respuesta de la 3ra pregunta');
          } else {
            val.EstadoId = 1;
            if (isCheckedregunta1_Ninguno == false) {
              if (
                isCheckedregunta1_1Dosis == true ||
                isCheckedregunta1_2Dosis == true ||
                isCheckedregunta1_3Dosis == true ||
                isCheckedregunta1_4Dosis == true
              ) {
                if (adjuntos.length == 0) {
                  message.warn('Por favor adjuntar archivos');
                  return;
                }
              }
            }
            message.loading({
              content: 'Por favor espere, estamos registrando la información...',
              key
            });
            setCargando(true);
            const request = new FormData();
            request.append('usuarioId', val.getFieldValue('Id'));
            request.append('pregunta1_1dosis', isCheckedregunta1_1Dosis == false ? '0' : '1');
            request.append(
              'pregunta1_1fecha',
              val.getFieldValue('pregunta1_1fecha') == undefined
                ? null
                : val.getFieldValue('pregunta1_1fecha').format('DD/MM/YYYY')
            );
            request.append('pregunta1_2dosis', isCheckedregunta1_2Dosis == false ? '0' : '1');
            request.append(
              'pregunta1_2fecha',
              val.getFieldValue('pregunta1_2fecha') == undefined
                ? null
                : val.getFieldValue('pregunta1_2fecha').format('DD/MM/YYYY')
            );
            request.append('pregunta1_3dosis', isCheckedregunta1_3Dosis == false ? '0' : '1');
            request.append(
              'pregunta1_3fecha',
              val.getFieldValue('pregunta1_3fecha') == undefined
                ? null
                : val.getFieldValue('pregunta1_3fecha').format('DD/MM/YYYY')
            );
            request.append('pregunta1_4dosis', isCheckedregunta1_4Dosis == false ? '0' : '1');
            request.append(
              'pregunta1_4fecha',
              val.getFieldValue('pregunta1_4fecha') == undefined
                ? null
                : val.getFieldValue('pregunta1_4fecha').format('DD/MM/YYYY')
            );
            request.append('pregunta1_2ninguno', isCheckedregunta1_Ninguno == false ? '0' : '1');
            request.append('pregunta2_pfizer', isCheckedregunta2_Pfizer == false ? '0' : '1');
            request.append(
              'pregunta2_aztrazeneca',
              isCheckedregunta2_AztraZeneca == false ? '0' : '1'
            );
            request.append('pregunta2_sinofarm', isCheckedregunta2_Sinofarm == false ? '0' : '1');
            request.append('pregunta2_jhonson', isCheckedregunta2_Jhonson == false ? '0' : '1');
            request.append('pregunta2_synovac', isCheckedregunta2_Synovac == false ? '0' : '1');
            request.append(
              'pregunta2_otradistinta',
              isCheckedregunta2_Otradistinta == false ? '0' : '1'
            );
            request.append(
              'pregunta2_descripcion_otradistinta',
              val.getFieldValue('pregunta2_descripcion_otradistinta') == undefined
                ? ''
                : val.getFieldValue('pregunta2_descripcion_otradistinta')
            );

            switch (value) {
              case 1:
                request.append('pregunta3_si', '1');
                request.append(
                  'pregunta3_si_fecha',
                  val.getFieldValue('pregunta3_si_fecha') == undefined
                    ? null
                    : val.getFieldValue('pregunta3_si_fecha').format('DD/MM/YYYY')
                );
                break;
              case 2:
                request.append('pregunta3_masdeunavez', '1');
                request.append(
                  'pregunta3_masdeunavez_fecha',
                  val.getFieldValue('pregunta3_masdeunavez_fecha') == undefined
                    ? null
                    : val.getFieldValue('pregunta3_masdeunavez_fecha').format('DD/MM/YYYY')
                );
                break;
              case 3:
                request.append('pregunta3_no', '1');
                break;
            }
            adjuntos.forEach((file) => {
              request.append('FormFiles', file);
            });
            const res: any = await carnetVacunacionProvider.carnetvacunacion(request);
            if (res) {
              setRegistroOk(true);
              setCargando(false);
              setficha(res);
              localStorage.removeItem('token');
              form.resetFields();
            }
          }
        }
      }
    },
    []
  );

  const buscarContacto = async (val) => {
    setCargandoContacto(true);
    const response: any = await seguridadProvider.obtenerContacto(val.currentTarget.value);
    setCargandoContacto(false);
    form.setFieldsValue({
      Referencia: response.contactoReferencia,
      TelefonoReferencia: response.telefonoReferencia,
      Direccion: response.direccion,
      Telefono: response.telefono
    });
  };
  const obtenerEmpresas = async () => {
    setCargandoEmpresas(true);
    const response: any = await administracionProvider.obtenerEmpresas();
    setEmpresas(response);
    setCargandoEmpresas(false);
  };

  const useResetFormOnCloseModal = ({ form, visible }) => {
    const prevVisibleRef = useRef();
    useEffect(() => {
      prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;
    useEffect(() => {
      if (!visible && prevVisible) {
        form.resetFields();
      }
    }, [visible]);
  };

  const ModalForm = ({ visible }) => {
    const [form] = Form.useForm();
    const [validando, setValidando] = useState(false);
    useResetFormOnCloseModal({ form, visible });

    const onOk = () => {
      form
        .validateFields()
        .then(async (val) => {
          const responseValidarCarnetVacunacion: any =
            await carnetVacunacionProvider.validar_carnetvacunacion_por_nro_documento({
              numerodocumento: val.dni
            });

          if (responseValidarCarnetVacunacion.succeeded) {
            message.warning(responseValidarCarnetVacunacion.message);
          } else {
            setValidando(true);
            const response = await seguridadProvider
              .ValidarEmpleadoCarnetVacunacion({
                Dni: val.dni,
                FechaNacimiento: val.fecha.format('DD/MM/YYYY')
              })
              .catch((err) => {
                if (err.response.status === 401) {
                  message.warning('El número de documento que ingresaste es incorrecto...');
                  form.resetFields();
                }
              });
            setValidando(false);
            if (response) {
              // intervalo();
              iniciarValores(); //
            }
          }
        })
        .catch((info) => {
          console.log('Validate Failed:', info);
        });
    };

    return (
      <Modal
        title={'Ingresa tu documento de identidad para iniciar registro.'}
        mask={true}
        closable={false}
        visible={visible}
        onOk={onOk}
        footer={[
          <Button key='submit' type='primary' loading={validando} onClick={onOk}>
            Validar
          </Button>
        ]}
      >
        <p>
          <InfoCircleOutlined twoToneColor='#eb2f96' /> Ten en cuenta que la información que
          proporciones tiene carácter de Declaración Jurada.
        </p>
        <p>
          <InfoCircleOutlined twoToneColor='#eb2f96' /> Antes de ingresar asegurate de tener el
          carnet de vacunacion en un archivo digital para subirlo.
        </p>
        <Form form={form} layout='vertical' name='userForm'>
          <Form.Item
            name='dni'
            label='Número de documento'
            rules={[{ required: true, message: 'Número de documento es requerido' }]}
          >
            <Input placeholder={'Ingrese su número de documento.'} />
          </Form.Item>
          <Form.Item
            name='fecha'
            label='Fecha de nacimiento'
            rules={[{ required: true, message: 'Fecha de nacimiento es requerido' }]}
          >
            <DatePicker placeholder={'dd/mm/yyyy'} locale={locale} format={'DD/MM/yyyy'} />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const mostrarPdf = async () => {
    message.info('Generando informe...');
    setVerPdf(true);
  };

  const [verPdf, setVerPdf] = useState(false);

  const FichaPdf = () => FichaPreview(ficha);

  const removeAdjunto = (file) => {
    const index = adjuntos.indexOf(file);
    const newFileList = adjuntos.slice();
    newFileList.splice(index, 1);
    setadjuntos([...newFileList]);
    setAdjunto({});
  };
  const beforeAdjunto = (file, files) => {
    setAdjunto(file);
    setadjuntos(files);
    return false;
  };
  const onChangeRadio = (e) => {
    console.log('radio checked', e.target.value);
    setIsDisabledpregunta3_si_fecha(true);
    setIsDisabledpregunta3_masdeunavez_fecha(true);
    if (e.target.value == 1) {
      setIsDisabledpregunta3_si_fecha(false);
    }
    if (e.target.value == 2) {
      setIsDisabledpregunta3_masdeunavez_fecha(false);
    }
    setValue(e.target.value); //
  };

  return (
    <>
      {registroOk ? (
        <Result
          icon={<SmileOutlined style={{ color: '#27AE60' }} />}
          title={'REGISTRO COMPLETO'}
        ></Result>
      ) : (
        <Card
          style={{ background: '#fffff', display: validado ? 'inline' : 'none' }}
          title={'Ficha De Vacunación COVID-19.'}
        >
          <Form
            form={form}
            onFinish={() =>
              handleOnFinish(
                form,
                value,
                isCheckedregunta1_1Dosis,
                isCheckedregunta1_2Dosis,
                isCheckedregunta1_3Dosis,
                isCheckedregunta1_4Dosis,
                isCheckedregunta1_Ninguno,
                tokenvalue,
                adjuntos,
                isCheckedregunta2_Pfizer,
                isCheckedregunta2_AztraZeneca,
                isCheckedregunta2_Sinofarm,
                isCheckedregunta2_Jhonson,
                isCheckedregunta2_Synovac,
                isCheckedregunta2_Otradistinta
              )
            }
            labelAlign='left'
            layout='horizontal'
          >
            <Form.Item label='Id' name='Id' noStyle>
              <Input type='hidden' />
            </Form.Item>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item name='EmpresaId' label='Razón social:'>
                  <Select placeholder='Seleccione Razón social' loading={cargandoEmpresas}>
                    {empresas.map((p, index) => {
                      return (
                        <Option key={index} value={p.id}>
                          {p.nombre}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='ruc' label='RUC:'>
                  <Input disabled={true} placeholder='Ingrese Ruc..' />
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <Form.Item name='NombreApellido' label='Apellidos y Nombres:'>
                  <Input allowClear={true} placeholder='Ingrese Apellidos y Nombres' />
                </Form.Item>
              </div>
              <div className='col-md-2'>
                <Form.Item
                  name='Dni'
                  validateStatus='validating'
                  hasFeedback={cargandoContacto}
                  label='DNI:'
                >
                  <Input onPressEnter={buscarContacto} placeholder='Dni' id='validating' />
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='Puesto' label='Puesto:'>
                  <Input readOnly={true} />
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item name='Direccion' label='Ingresa tu dirección:'>
                  <Input placeholder='Ingrese Dirección...' />
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='Telefono' label='Teléfono:'>
                  <Input placeholder='Ingrese Telefono' />
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item name='Referencia' label='Contacto referencia:'>
                  <Input />
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Form.Item name='TelefonoReferencia' label='Telefono de referencia:'>
                  <Input />
                </Form.Item>
              </div>
            </div>
            <Divider>Preguntas</Divider>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item label={'1. ¿Haz recibido la vacuna por COVID-19?'}></Form.Item>
                <div className='row'>
                  <div className='col-md-2'>
                    <Form.Item name='pregunta1_1dosis'>
                      <Checkbox
                        disabled={isDisabledpregunta1CheckboxPregunta1}
                        checked={isCheckedregunta1_1Dosis}
                        onChange={(val) => {
                          setIsCheckedregunta1_1Dosis(val.target.checked);
                          setIsDisabledpregunta1_1fecha(!val.target.checked);

                          setIsDisabledpregunta1CheckboxPregunta2(!val.target.checked);
                          if (val.target.checked == false) {
                            setIsDisabledpregunta1CheckboxPregunta3(true);
                            setIsDisabledpregunta1CheckboxPregunta4(true);
                          }

                          setIsCheckedregunta1_2Dosis(false);
                          setIsDisabledpregunta1_2fecha(true);

                          setIsCheckedregunta1_3Dosis(false);
                          setIsDisabledpregunta1_3fecha(true);

                          setIsCheckedregunta1_4Dosis(false);
                          setIsDisabledpregunta1_4fecha(true);
                        }}
                      >
                        1 Dosis
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className='col-md-3'>
                    <Form.Item
                      name='pregunta1_1fecha'
                      label='Fecha'
                      rules={
                        isCheckedregunta1_1Dosis == true
                          ? [
                              {
                                required: true,
                                message: 'Fecha es requerido!'
                              }
                            ]
                          : null
                      }
                    >
                      <DatePicker
                        disabled={isDisabledpregunta1_1fecha}
                        placeholder={'dd/mm/yyyy'}
                        locale={locale}
                        format={'DD/MM/yyyy'}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-2'>
                    <Form.Item name='pregunta1_2dosis'>
                      <Checkbox
                        disabled={isDisabledpregunta1CheckboxPregunta2}
                        checked={isCheckedregunta1_2Dosis}
                        onChange={(val) => {
                          setIsCheckedregunta1_2Dosis(val.target.checked);
                          setIsDisabledpregunta1_2fecha(!val.target.checked);

                          setIsDisabledpregunta1CheckboxPregunta3(!val.target.checked);
                          if (val.target.checked == false) {
                            setIsDisabledpregunta1CheckboxPregunta4(true);
                          }

                          setIsCheckedregunta1_3Dosis(false);
                          setIsDisabledpregunta1_3fecha(true);
                        }}
                      >
                        2 Dosis
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className='col-md-3'>
                    <Form.Item
                      name='pregunta1_2fecha'
                      label='Fecha'
                      rules={
                        isCheckedregunta1_2Dosis == true
                          ? [
                              {
                                required: true,
                                message: 'Fecha es requerido!'
                              }
                            ]
                          : null
                      }
                    >
                      <DatePicker
                        disabled={isDisabledpregunta1_2fecha}
                        placeholder={'dd/mm/yyyy'}
                        locale={locale}
                        format={'DD/MM/yyyy'}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-2'>
                    <Form.Item name='pregunta1_3dosis'>
                      <Checkbox
                        disabled={isDisabledpregunta1CheckboxPregunta3}
                        checked={isCheckedregunta1_3Dosis}
                        onChange={(val) => {
                          setIsCheckedregunta1_3Dosis(val.target.checked);
                          setIsDisabledpregunta1_3fecha(!val.target.checked);

                          setIsDisabledpregunta1CheckboxPregunta4(!val.target.checked);
                          setIsCheckedregunta1_4Dosis(false);
                          setIsDisabledpregunta1_4fecha(true);
                        }}
                      >
                        3 Dosis
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className='col-md-3'>
                    <Form.Item
                      name='pregunta1_3fecha'
                      label='Fecha'
                      rules={
                        isCheckedregunta1_3Dosis == true
                          ? [
                              {
                                required: true,
                                message: 'Fecha es requerido!'
                              }
                            ]
                          : null
                      }
                    >
                      <DatePicker
                        disabled={isDisabledpregunta1_3fecha}
                        placeholder={'dd/mm/yyyy'}
                        locale={locale}
                        format={'DD/MM/yyyy'}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-2'>
                    <Form.Item name='pregunta1_4dosis'>
                      <Checkbox
                        disabled={isDisabledpregunta1CheckboxPregunta4}
                        checked={isCheckedregunta1_4Dosis}
                        onChange={(val) => {
                          setIsCheckedregunta1_4Dosis(val.target.checked);
                          setIsDisabledpregunta1_4fecha(!val.target.checked);
                        }}
                      >
                        4 Dosis
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className='col-md-3'>
                    <Form.Item
                      name='pregunta1_4fecha'
                      label='Fecha'
                      rules={
                        isCheckedregunta1_4Dosis == true
                          ? [
                              {
                                required: true,
                                message: 'Fecha es requerido!'
                              }
                            ]
                          : null
                      }
                    >
                      <DatePicker
                        disabled={isDisabledpregunta1_4fecha}
                        placeholder={'dd/mm/yyyy'}
                        locale={locale}
                        format={'DD/MM/yyyy'}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-2'>
                    <Form.Item name='pregunta1_2ninguno'>
                      <Checkbox
                        checked={isCheckedregunta1_Ninguno}
                        onChange={(val) => {
                          setIsCheckedregunta1_Ninguno(val.target.checked);
                          setIsCheckedregunta1_1Dosis(false); /*Limiamos checbox marcados*/
                          setIsDisabledpregunta1_1fecha(true);
                          setIsDisabledpregunta1CheckboxPregunta1(val.target.checked);

                          setIsCheckedregunta1_2Dosis(false); /*Limiamos checbox marcados*/
                          setIsDisabledpregunta1_2fecha(true);
                          setIsDisabledpregunta1CheckboxPregunta2(true);

                          setIsCheckedregunta1_3Dosis(false); /*Limiamos checbox marcados*/
                          setIsDisabledpregunta1_3fecha(true);
                          setIsDisabledpregunta1CheckboxPregunta3(true);

                          setIsCheckedregunta1_4Dosis(false); /*Limiamos checbox marcados*/
                          setIsDisabledpregunta1_4fecha(true);
                          setIsDisabledpregunta1CheckboxPregunta4(true);

                          setIsDisabledregunta2(val.target.checked);
                        }}
                      >
                        Ninguna
                      </Checkbox>
                    </Form.Item>
                  </div>
                </div>
                <Form.Item label={'2. ¿Con que vacuna le realizaron la inmunización?'}></Form.Item>
                <Form.Item name='pregunta2_pfizer'>
                  <Checkbox
                    disabled={isDisabledregunta2}
                    checked={isCheckedregunta2_Pfizer}
                    onChange={(val) => {
                      setIsCheckedregunta2_Pfizer(val.target.checked);
                    }}
                  >
                    Pfizer
                  </Checkbox>
                </Form.Item>
                <Form.Item name='pregunta2_aztrazeneca'>
                  <Checkbox
                    disabled={isDisabledregunta2}
                    checked={isCheckedregunta2_AztraZeneca}
                    onChange={(val) => {
                      setIsCheckedregunta2_AztraZeneca(val.target.checked);
                    }}
                  >
                    AztraZeneca
                  </Checkbox>
                </Form.Item>
                <Form.Item name='pregunta2_sinofarm'>
                  <Checkbox
                    disabled={isDisabledregunta2}
                    checked={isCheckedregunta2_Sinofarm}
                    onChange={(val) => {
                      setIsCheckedregunta2_Sinofarm(val.target.checked);
                    }}
                  >
                    Sinofarm
                  </Checkbox>
                </Form.Item>
                <Form.Item name='pregunta2_jhonson'>
                  <Checkbox
                    disabled={isDisabledregunta2}
                    checked={isCheckedregunta2_Jhonson}
                    onChange={(val) => {
                      setIsCheckedregunta2_Jhonson(val.target.checked);
                    }}
                  >
                    Jhonson & Jhonson
                  </Checkbox>
                </Form.Item>
                <Form.Item name='pregunta2_synovac'>
                  <Checkbox
                    disabled={isDisabledregunta2}
                    checked={isCheckedregunta2_Synovac}
                    onChange={(val) => {
                      setIsCheckedregunta2_Synovac(val.target.checked);
                    }}
                  >
                    Synovac
                  </Checkbox>
                </Form.Item>
                <div className='row'>
                  <div className='col-md-2'>
                    <Form.Item name='pregunta2_otradistinta'>
                      <Checkbox
                        disabled={isDisabledregunta2}
                        checked={isCheckedregunta2_Otradistinta}
                        onChange={(val) => {
                          setIsCheckedregunta2_Otradistinta(val.target.checked);
                        }}
                      >
                        Otra distinta especificar:{' '}
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className='col-md-4'>
                    <Form.Item name='pregunta2_descripcion_otradistinta'>
                      <Input.TextArea
                        disabled={isDisabledregunta2}
                        placeholder='Descripción'
                        rows={2}
                      />
                    </Form.Item>
                  </div>
                </div>
                <Form.Item label={'3. ¿Le ha dado COVID-19 confirmado anteriormente?'}></Form.Item>
                <div className='row'>
                  <div className='col-md-12'>
                    <Radio.Group onChange={onChangeRadio} value={value}>
                      <Space direction='vertical'>
                        <div className='row'>
                          <div className='col-md-6'>
                            <Radio value={1}>Sí, una sola vez</Radio>
                          </div>
                          <div className='col-md-6'>
                            <Form.Item
                              name='pregunta3_si_fecha'
                              label='Fecha'
                              rules={
                                value == 1
                                  ? [{ required: true, message: 'Fecha es requerido!' }]
                                  : null
                              }
                            >
                              <DatePicker
                                disabled={isDisabledpregunta3_si_fecha}
                                placeholder={'dd/mm/yyyy'}
                                locale={locale}
                                format={'DD/MM/yyyy'}
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <Row>
                          <Col span={12}>
                            <Radio value={2}>Sí, más de una vez</Radio>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name='pregunta3_masdeunavez_fecha'
                              label='Fecha de la ultima re infección'
                              rules={
                                value == 2
                                  ? [{ required: true, message: 'Fecha es requerido!' }]
                                  : null
                              }
                            >
                              <DatePicker
                                disabled={isDisabledpregunta3_masdeunavez_fecha}
                                placeholder={'dd/mm/yyyy'}
                                locale={locale}
                                format={'DD/MM/yyyy'}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <Radio value={3}>No he tenido Covid</Radio>
                          </Col>
                        </Row>
                      </Space>
                    </Radio.Group>
                  </div>
                </div>
                <br />
                <Form.Item>
                  Todos los datos expresados en esta ficha constituyen declaración jurada de mi
                  parte.
                  <br />
                  He sido informado que de omitir o declarar información falsa puedo perjudicar la
                  salud de mis compañeros y la mía propia, asumiendo las responsabilidades que
                  correspondan.
                  <br />
                  Autorizo a la empresa el adecuado uso de los datos consignados en la presente
                  declaración jurada de acuerdo a lo establecido en la Ley N° 29733.
                </Form.Item>
              </div>
              <div className='col-md-4'>
                <Image width={'100%'} src='/content/vacuna.jpeg' preview={true} /> <br />
                <Form.Item style={{ display: 'inline-block', width: '100%', margin: '10px 8px' }}>
                  <Upload
                    multiple
                    fileList={adjuntos}
                    onRemove={removeAdjunto}
                    beforeUpload={beforeAdjunto}
                    className='avatar-uploader'
                  >
                    <Button type={'dashed'} icon={<UploadOutlined />}>
                      Subir imagen de las dos caras del carnet de vacunación
                    </Button>
                  </Upload>
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <Form.Item>
                  <Button
                    loading={cargando}
                    disabled={restringido}
                    htmlType={'submit'}
                    type='primary'
                  >
                    {' '}
                    ENVIAR
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </Card>
      )}
      <ModalForm visible={mostrarValidarUsuario} />
    </>
  );
};

export default CarnetVacunacion;
